// The selected proof mode controls which approval UI may render.
// Complete-package decisions belong to the package panel only; unknown
// or partially hydrated mappings must not become per-location approvals.
export const shouldShowMappedArtworkProof = ({
  hasProof,
  isCompletePackageProof,
  isPerLocationProof,
  canShowPerLocation,
  hasCompleteApprovalPackage = false,
}) =>
  Boolean(hasProof && !hasCompleteApprovalPackage && !isCompletePackageProof && isPerLocationProof && canShowPerLocation);
